export default __webpack_public_path__ + "static/media/home-background.91d38341.png";